var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',[_vm._v("Tariff Details")]),_c('v-card-text',[_vm._v("This product uses a legacy tariff, please use the old CRM to view the tariff")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }